import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Popconfirm,
  notification,
  Tooltip,
  Drawer,
  Modal,
  message,
} from "antd";
import {
  OrderedListOutlined,
  EditOutlined,
  DeleteOutlined,
  FormOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import OrderDeliveryTableFilter from "../Filters/OrderDeliveryTableFilter";
import moment from "moment";
import OrderDeliveryUpdateForm from "../Forms/OrderDeliveryUpdateForm";
import OrderDeliveryAddForm from "../Forms/OrderDeliveryAddForm";
import config from "../../util/ApiforContext";

const OrderDeliveryList = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "TESLİMAT KAYDI LİSTESİ",
  });
  const [quotes, setQuotes] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const history = useHistory();
  const [orderDeliveryAddModalVisible, setOrderDeliveryAddModalVisible] =
    useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [orderDeliveryUpdateModalVisible, setOrderDeliveryUpdateModalVisible] =
    useState(false);
  const [existingFiles, setExistingFiles] = useState([]);

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setQuotes({
      ...quotes,
      loading: true,
    });

    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/OrderDelivery?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setQuotes({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  };

  const handleOnClickUpdate = (record) => {
    setUpdateFormData(record);
    setSelectedOrderId(record.id);
    setOrderDeliveryUpdateModalVisible(true);
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const handleOnClickDelete = (row) => {
    // if (row.addUserId !== localStorage.getItem("userId") && !isEditAllowed) {
    //   openNotificationForNotAuthWithIcon("warning");
    //   return;
    // }

    RequestHandler.delete(`/OrderDelivery/${row.id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const columns = [
    {
      title: "Teslimat Numarası",
      dataIndex: "deliveryNumber",
      key: "deliveryNumber",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Teslimat Tarihi",
      dataIndex: "deliveryDate",
      key: "deliveryDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY") : "-"),
    },
    {
      title: "Sipariş Kodu",
      dataIndex: "orderName",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Proje Adı",
      dataIndex: "firmName",
      key: "firmName",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Eklenme Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      render: (data) =>
        data ? moment(data).format("DD.MM.YYYY HH:mm:ss") : "-",
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a onClick={() => handleOnClickUpdate(row)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data, row) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(row)}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setQuotes(e);
  };

  const onSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  // const handleOnClickStatusUpdate = (row) => {
  //   setUpdateFormData({
  //     id: row.id,
  //     name: row.name,
  //     orderStatus: row.statusByte,
  //   });
  //   setUpdateFormVisibility(true);
  // };

  const expandedRowRender = (data) => {
    const columns = [
      {
        title: "Malzeme Adı",
        dataIndex: "name",
        key: "name",
        align: "center",
        render: (text) => {
          return (
            <Tooltip placement="topLeft" title={text}>
              <div style={{ whiteSpace: "break-spaces" }}>
                {text?.substring(0, 20)?.length < 20
                  ? text?.substring(0, 20) + ""
                  : text?.substring(0, 20) + "..."}
              </div>
            </Tooltip>
          );
        },
      },

      {
        title: "Stok Kodu",
        dataIndex: "stockCode",
        key: "stockCode",
        align: "left",
        render: (text) => {
          return (
            <Tooltip placement="topLeft" title={text}>
              <div style={{ whiteSpace: "break-spaces" }}>
                {text?.substring(0, 20)?.length < 20
                  ? text?.substring(0, 20) + ""
                  : text?.substring(0, 20) + "..."}
              </div>
            </Tooltip>
          );
        },
      },
      {
        title: "Sipariş Miktarı",
        dataIndex: "orderQuantity",
        key: "orderQuantity",
        align: "center",
      },
      {
        title: "Teslimat Miktarı",
        dataIndex: "quantity",
        key: "quantity",
        align: "center",
      },
    ];

    return (
      <Table
        columns={columns}
        size="small"
        dataSource={data}
        pagination={false}
        rowClassName={(record) =>
          record.isCompleted ? "row-completed" : "table-row-default"
        }
      />
    );
  };

  const exportExcel = () => {
    const hide = message.loading("Excel indiriliyor...", 0);
    const { filter } = tableDataQueryOptions;
    RequestHandler.post(
      `/OrderDeliveryExcel/ExportExcel`,
      { Query: filter == "" ? "" : "$filter=" + filter },
      false,
      {
        rawResponse: true,
      }
    ).then((res) => {
      if (res.status == 200) {
        window.open(
          `${config.apiUrl}/OrderDeliveryExcel/DownloadExcelList?fileName=${
            res.data
          }&t=${RequestHandler.getToken()}`
        );
      }
      hide();
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={exportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
          <a>
            <Button
              style={{ marginRight: 15 }}
              type="primary"
              onClick={() => {
                setSelectedOrderId(null);
                setOrderDeliveryAddModalVisible(true);
              }}
            >
              Teslimat Kaydı Ekle
            </Button>
          </a>
        </Col>
      </Row>

      <OrderDeliveryTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            expandable={{
              expandedRowRender: (record) =>
                expandedRowRender(record.orderDeliveryItems),
              rowExpandable: (record) => record.orderDeliveryItems !== null,
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            dataSource={quotes.data}
            loading={quotes.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: quotes.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>

      <Modal
        visible={orderDeliveryAddModalVisible}
        title="Teslimat Kaydı Ekle"
        footer={null}
        onCancel={() => setOrderDeliveryAddModalVisible(false)}
        width={800}
        destroyOnClose={true}
      >
        <OrderDeliveryAddForm
          onCancel={() => setOrderDeliveryAddModalVisible(false)}
          onSuccess={() => {
            setOrderDeliveryAddModalVisible(false);
            // refresh list vb.
            getTableData();
          }}
          orderId={selectedOrderId}
          isDefaultAdd={true}
        />
      </Modal>

      <Modal
        visible={orderDeliveryUpdateModalVisible}
        title="Teslimat Kaydı Güncelle"
        footer={null}
        onCancel={() => setOrderDeliveryUpdateModalVisible(false)}
        width={800}
        destroyOnClose={true}
      >
        <OrderDeliveryUpdateForm
          onCancel={() => setOrderDeliveryUpdateModalVisible(false)}
          onSuccess={() => {
            setOrderDeliveryUpdateModalVisible(false);
            // refresh list vb.
            getTableData();
          }}
          data={updateFormData}
          existingFiles={existingFiles}
        />
      </Modal>
    </>
  );
};

export default OrderDeliveryList;
